<template>
	<page>
		<title-view>
			מסך קופונים
			<v-btn
				slot="actions"
				btn
				color="green"
				@click="onEdit({})"
			>
				הוסף קופון
			</v-btn>
		</title-view>
		<row>
			<c-col>
				<coupons-table @edit="onEdit" />
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">יצירת/עריכת קופון</span>
			<coupon-form
				v-if="openModal"
				@save="openModal=false"
			/>
		</popup-dialog>
	</page>
</template>

<script>
import CouponsTable from "./CouponsTable";
import CouponForm from "./CouponForm";
import { types } from "src/store/modules/Coupon.module";

export default {
	name: "CouponsView",
	components: { CouponsTable, CouponForm },
	data () {
		return {
			openModal: false,
		};
	},
	methods: {
		onEdit (coupon) {
			this.$store.commit(types.GET, coupon);
			this.openModal = true;
		},
	},
};
</script>

<style scoped>

</style>
